import { useMemo } from 'react'
import { useRouteError } from 'react-router'
import { ErrorPage } from '../components/error-pages/error-page.tsx'
import { generateReference } from '../lib/reference.ts'

// RAL-162 rule 7 ("signed in, the shell stays"): this boundary sits on a pathless route nested
// under RootLayout's <Outlet/>, one level below Nav — so unlike RootErrorBoundary (which
// replaces the entire root route, nav bar included), a thrown loader/render error here only
// replaces the main column's content. See router.tsx for where this attaches.
//
// We don't branch on the error's shape (same call as RootErrorBoundary — see that file):
// every route-level throw maps to the generic `server` failure class. A more specific failure
// class (agent_run, publisher, tiktok_down, ...) requires the throwing code to say which one,
// which is per-call-site wiring left for follow-up rather than guessed at here.
export default function InShellErrorBoundary() {
  const error = useRouteError()
  if (import.meta.env.DEV) console.error(error)

  const reference = useMemo(() => generateReference(), [])

  return (
    <ErrorPage
      variant="shell"
      failureClass="server"
      publisherStatus={{ state: 'unknown' }}
      reference={reference}
      onRetry={() => window.location.reload()}
    />
  )
}
